export default __webpack_public_path__ + "static/media/browserify-icon.11848481.svg";